import { useMemo } from 'react';
import { getOrganizationId, parseAllowedOrganizations } from 'utils/auth';
import { useUserStateStore } from 'zstore/userStateStore';

/**
 * Returns true when the current user belongs to one of the GV internal
 * organisations defined in VITE_CLONING_ALLOWED_ORGS.
 */
const useIsInternalOrg = (): boolean => {
  const { user } = useUserStateStore();
  const userOrgId = getOrganizationId(user);

  return useMemo(() => {
    const allowedOrgs = parseAllowedOrganizations(import.meta.env.VITE_CLONING_ALLOWED_ORGS);
    return Boolean(userOrgId) && allowedOrgs.includes(userOrgId);
  }, [userOrgId]);
};

export default useIsInternalOrg;
